import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function homeRCTIReducer(state = initialState.clientRequests, action) {
  switch (action.type) {
    case types.LIST_PENDING_REQUESTS:
      return {
        ...state, list: action.items
      };
    case types.CLEAR_PENDING_REQUESTS: 
        return {
            ...state, list: []
          };
    case types.GET_PENDING_REQUESTS_COUNT:
      return {
        ...state, total: action.items
      };
    case types.CLEAR_PENDING_REQUESTS_COUNT: 
        return {
            ...state, total: 0
          };
    default:
      return state;
  }
}
